module.exports = __webpack_public_path__ + "static/media/52_B.0d1eabfe.png";